import Vue from "vue"
import VueRouter from "vue-router"
import store from "@/store/index"
import LandingPage from "@/views/LandingPage"
import ManagerLanding from "@/views/ManagerLanding"
import DiagnosticPage from "@/views/DiagnosticPage"
import KeyMeasuresPage from "@/views/KeyMeasuresPage"
import KeyMeasuresHome from "@/views/KeyMeasuresPage/KeyMeasuresHome"
import KeyMeasurePage from "@/views/KeyMeasuresPage/KeyMeasurePage"
import GeneratePosterPage from "@/views/GeneratePosterPage"
import CanteensPage from "@/views/CanteensPage"
import CanteenWidget from "@/views/CanteensPage/CanteenWidget"
import CanteenSearchLanding from "@/views/CanteenSearchLanding"
import CanteensHome from "@/views/CanteensPage/CanteensHome"
import CanteenPage from "@/views/CanteensPage/CanteenPage"
import LegalNotices from "@/views/LegalNotices"
import AccountSummaryPage from "@/views/AccountSummaryPage"
import AccountEditor from "@/views/AccountSummaryPage/AccountEditor"
import PasswordChangeEditor from "@/views/AccountSummaryPage/PasswordChangeEditor"
import AccountDeletion from "@/views/AccountSummaryPage/AccountDeletion"
import BlogsPage from "@/views/BlogsPage"
import BlogsHome from "@/views/BlogsPage/BlogsHome"
import BlogPage from "@/views/BlogsPage/BlogPage"
import SurveyLinksPage from "@/views/SurveyLinksPage"
import SurveyLinksHome from "@/views/SurveyLinksPage/SurveyLinksHome"
import EatingStudyPage from "@/views/EatingStudyPage"
import EatingStudyHome from "@/views/EatingStudyPage/EatingStudyHome"
import CreateEatingStudy from "@/views/EatingStudyPage/CreateEatingStudy"
import EatingExperiencePage from "@/views/EatingExperiencePage"
import CreateEatingExperience from "../views/EatingExperiencePage/CreateEatingExperience"
import ConcernsPage from "@/views/ConcernsPage"
import CreateConcerns from "../views/ConcernsPage/CreateConcerns"
import PartnersPage from "@/views/PartnersPage"
import PartnersHome from "@/views/PartnersPage/PartnersHome"
import PartnerPage from "@/views/PartnersPage/PartnerPage"
import NewPartner from "@/views/NewPartner"
import NotFound from "@/views/NotFound"
import CGU from "@/views/CGU.vue"
import PrivacyPolicy from "@/views/PrivacyPolicy"
import ManagementPage from "@/views/ManagementPage"
import PendingActions from "@/views/PendingActions"
import CanteenEditor from "@/views/CanteenEditor"
import CanteenForm from "@/views/CanteenEditor/CanteenForm"
import SatelliteManagement from "@/views/CanteenEditor/SatelliteManagement"
import CanteenManagers from "@/views/CanteenEditor/CanteenManagers"
import CanteenGeneratePoster from "@/views/CanteenEditor/CanteenGeneratePoster"
import CanteenDeletion from "@/views/CanteenEditor/CanteenDeletion"
import PublicationForm from "@/views/CanteenEditor/PublicationForm"
import PublishSatellites from "@/views/CanteenEditor/PublishSatellites"
import DiagnosticTunnel from "@/views/DiagnosticTunnel"
import DiagnosticsImporter from "@/views/DiagnosticsImporter"
import DiagnosticImportPage from "@/views/DiagnosticsImporter/DiagnosticImportPage"
import PublicCanteenStatisticsPage from "@/views/PublicCanteenStatisticsPage"
import AccessibilityDeclaration from "@/views/AccessibilityDeclaration"
import ContactPage from "@/views/ContactPage"
import PurchasesHome from "@/views/PurchasesHome"
import PurchasePage from "@/views/PurchasePage"
import PurchasesImporter from "@/views/PurchasesImporter"
import PurchasesSummary from "@/views/PurchasesSummary"
import CommunityPage from "@/views/CommunityPage"
import FaqPage from "@/views/FaqPage"
import SiteMap from "@/views/SiteMap"
import DeveloperPage from "@/views/DeveloperPage"
import ImpactMeasuresPage from "@/views/ImpactMeasuresPage"
import DashboardManager from "@/views/DashboardManager"
import TerritoryCanteens from "@/views/TerritoryCanteens"
import VideoTutorial from "@/views/VideoTutorial"
import MyProgress from "@/views/MyProgress"
import Constants from "@/constants"
import BlankPage from "@/views/BlankPage"
import ActionPlan from "@/views/ActionPlan"
import CreateAction from "@/views/ActionPlan/CreateAction"
import ActionDetails from "../views/ActionPlan/ActionDetails"
import ContactLabSoft from "@/views/ContactLabSoft.vue"
import ManageResults from "@/views/ManageResults"
import RestaurantDashboardPage from "@/views/RestaurantDashboardPage"
import WasteDiagnosticPage from "@/views/WasteDiagnosticPage"
import FirstDiagnosticPage from "@/views/FirstDiagnosticPage"
import OnlineDeclarationPage from "@/views/OnlineDeclarationPage"
import WasteDiagnosticResumePage from "@/views/WasteDiagnosticResumePage"
import CantineNewDashboard from "@/views/CantineNewDashboard"
import KezakoPage from "@/views/KezakoPage"
import NextMeeting from "../views/NextMeeting"

// import WasteActionsPage from "@/views/WasteActionsPage"
// import WasteActionsHome from "@/views/WasteActionsPage/WasteActionsHome.vue"
// import WasteActionPage from "@/views/WasteActionsPage/WasteActionPage.vue"
import GestionnairePage from "@/views/GestionnairePage"
import NutritionistePage from "@/views/NutritionistePage"
import ConvivePage from "@/views/ConvivePage"

Vue.use(VueRouter)

const routes = [
  {
    path: "/espace-gestionnaire",
    name: "GestionnairePage",
    component: GestionnairePage,
    meta: {
      title: "Espace Gestionnaire",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/espace-convive",
    name: "ConvivePage",
    component: ConvivePage,
    meta: {
      title: "Espace Convive",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/espace-nutritioniste",
    name: "NutritionistePage",
    component: NutritionistePage,
    meta: {
      title: "Espace Nutritioniste",
      authenticationRequired: false,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/",
    meta: {
      home: true,
    },
  },
  {
    path: "/accueil",
    name: "LandingPage",
    component: LandingPage,
  },
  {
    path: "/blank-page-(test)",
    name: "BlankPage",
    component: BlankPage,
  },
  {
    path: "/actions",
    name: "ActionPlan",
    component: ActionPlan,
    meta: {
      title: "Plan d'actions",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/actions/create",
    name: "CreateAction",
    component: CreateAction,
    meta: {
      title: "Ajouter une action",
      authenticationRequired: true,
    },
  },
  {
    path: "/actions/:id/details",
    name: "ActionDetails",
    component: ActionDetails,
    meta: {
      title: "Instructions",
      authenticationRequired: true,
    },
  },
  {
    path: "/contact",
    name: "ContactLabSoft",
    component: ContactLabSoft,
    meta: {
      title: "Contact",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/results",
    name: "ManageResults",
    component: ManageResults,
  },
  {
    path: "/accueil-gestionnaire",
    name: "ManagerLanding",
    component: ManagerLanding,
    beforeEnter: (_to, _from, next) => {
      store.state.loggedUser ? next({ name: "ManagementPage" }) : next()
    },
  },
  {
    path: "/mon-compte",
    name: "AccountSummaryPage",
    component: AccountSummaryPage,
    redirect: { name: "AccountEditor" },
    children: [
      {
        path: "profil",
        name: "AccountEditor",
        component: AccountEditor,
        meta: {
          authenticationRequired: true,
          title: "Mon compte",
        },
        sitemapGroup: Constants.SitemapGroups.SITE,
      },
      {
        path: "mot-de-passe",
        name: "PasswordChange",
        component: PasswordChangeEditor,
        meta: {
          authenticationRequired: true,
          title: "Changer mon mot de passe",
        },
      },
      {
        path: "supprimer-mon-compte",
        name: "AccountDeletion",
        component: AccountDeletion,
        meta: {
          authenticationRequired: true,
          title: "Supprimer mon compte",
        },
      },
    ],
  },
  {
    path: "/diagnostic",
    name: "DiagnosticPage",
    component: DiagnosticPage,
    meta: {
      title: "M'auto-évaluer",
    },
    beforeEnter: (_to, _from, next) => {
      store.state.loggedUser ? next({ name: "ManagementPage" }) : next()
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/creation-affiche",
    name: "GeneratePosterPage",
    component: GeneratePosterPage,
    meta: {
      title: "Affiche convives",
    },
    //sitemapGroup: Constants.SitemapGroups.ACTION,
  },
  {
    path: "/mesures-phares",
    name: "KeyMeasuresPage",
    component: KeyMeasuresPage,
    redirect: { name: "KeyMeasuresHome" },
    children: [
      {
        path: "",
        name: "KeyMeasuresHome",
        component: KeyMeasuresHome,
        meta: {
          title: "Tableau de bord",
        },
        beforeEnter: (route, _, next) => {
          store.state.loggedUser
            ? next({
                name: "KeyMeasurePage",
                params: {
                  id: "qualite-des-produits",
                },
              })
            : next()
        },
      },
      {
        path: ":id",
        name: "KeyMeasurePage",
        component: KeyMeasurePage,
        props: true,
      },
    ],
    meta: {
      title: "Les mesures phares",
    },
  },
  {
    path: "/trouver-une-cantine",
    name: "CanteenSearchLanding",
    component: CanteenSearchLanding,
    meta: {
      title: "Trouver une cantine",
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    // if you change this path, update the visitor view count logic in the publication widget
    path: "/nos-cantines",
    component: CanteensPage,
    children: [
      {
        path: "",
        name: "CanteensHome",
        component: CanteensHome,
        meta: {
          title: "Les cantines",
        },
      },
      {
        path: ":canteenUrlComponent",
        name: "CanteenPage",
        component: CanteenPage,
        props: true,
      },
    ],
  },
  {
    path: "/widgets/nos-cantines/:canteenUrlComponent",
    name: "CanteenWidget",
    component: CanteenWidget,
    props: true,
  },
  {
    path: "/mentions-legales",
    name: "LegalNotices",
    component: LegalNotices,
    meta: {
      title: "Mentions légales",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/blog",
    component: BlogsPage,
    children: [
      {
        path: "",
        name: "BlogsHome",
        component: BlogsHome,
        meta: {
          title: "Blog",
        },
        // sitemapGroup: Constants.SitemapGroups.LAW,
      },
      {
        path: ":id",
        name: "BlogPage",
        component: BlogPage,
        props: true,
      },
    ],
  },
  // {
  //   path: "/actions-anti-gaspi",
  //   component: WasteActionsPage,
  //   children: [
  //     {
  //       path: "",
  //       name: "WasteActionsHome",
  //       component: WasteActionsHome,
  //       meta: {
  //         title: "Actions anti-gaspi",
  //       },
  //       sitemapGroup: Constants.SitemapGroups.ACTION,
  //     },
  //     {
  //       path: ":id",
  //       name: "WasteActionPage",
  //       component: WasteActionPage,
  //       props: true,
  //     },
  //   ],
  // },
  {
    path: "/donner-ou-voir-mes-avis",
    component: SurveyLinksPage,
    children: [
      {
        path: "",
        name: "SurveyLinksHome",
        component: SurveyLinksHome,
        meta: {
          title: "Donner ou voir mes avis",
        },
        sitemapGroup: Constants.SitemapGroups.CONSUMER,
      },
    ],
  },
  {
    path: "/action-plan",
    name: "ActionPlan",
    component: ActionPlan,
    meta: {
      title: "ActionPlan",
      authenticationRequired: true,
    },
  },
  {
    path: "/partenaires",
    redirect: "/acteurs-de-l-eco-systeme",
  },
  {
    path: "/acteurs-de-l-eco-systeme",
    component: PartnersPage,
    children: [
      {
        path: "",
        name: "PartnersHome",
        component: PartnersHome,
        meta: {
          title: "Acteurs de l'éco-système",
        },
        //sitemapGroup: Constants.SitemapGroups.ACTION,
      },
      {
        path: ":partnerUrlComponent",
        name: "PartnerPage",
        component: PartnerPage,
        props: true,
      },
    ],
  },
  {
    path: "/nouveau-acteur-de-l-ecosysteme",
    name: "NewPartner",
    component: NewPartner,
    meta: {
      title: "Nouvel acteur de l'éco-système",
    },
    //sitemapGroup: Constants.SitemapGroups.ACTION,
  },
  {
    path: "/cgu",
    name: "CGU",
    component: CGU,
    meta: {
      title: "Conditions générales d'utilisation",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/politique-de-confidentialite",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: {
      title: "Politique de confidentialité",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/gestion",
    name: "ManagementPage",
    component: ManagementPage,
    meta: {
      title: "Mon tableau de bord",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/actions-en-attente",
    name: "PendingActions",
    component: PendingActions,
    meta: {
      title: "Actions en attente",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.ACTION,
  },
  {
    path: "/nouvelle-cantine",
    name: "NewCanteen",
    component: CanteenEditor,
    redirect: { name: "NewCanteenForm" },
    children: [
      {
        path: "",
        name: "NewCanteenForm",
        component: CanteenForm,
        meta: {
          title: "Ajouter ma cantine",
          authenticationRequired: true,
        },
        //sitemapGroup: Constants.SitemapGroups.ACTION,
      },
    ],
  },
  {
    path: "/eating-experience",
    name: "EatingExperiencePage",
    component: EatingExperiencePage,
    meta: {
      title: "Solutions répertoriées",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/eating-experience/create",
    name: "CreateEatingExperience",
    component: CreateEatingExperience,
    meta: {
      title: "Ajouter une solution",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/concerns",
    name: "ConcernsPage",
    component: ConcernsPage,
    meta: {
      title: "Préoccupation",
      authenticationRequired: true,
    },
  },
  {
    path: "/concerns/create",
    name: "CreateConcerns",
    component: CreateConcerns,
    meta: {
      title: "Ajouter une préoccupation",
      authenticationRequired: true,
    },
  },
  {
    path: "/study-eating",
    component: EatingStudyPage,
    children: [
      {
        path: "/study-eat",
        name: "EatingStudyHome",
        component: EatingStudyHome,
        meta: {
          title: "Actions en cours",
          authenticationRequired: true,
        },
        sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
      },
      {
        path: "/create",
        name: "CreateEatingStudy",
        component: CreateEatingStudy,
        meta: {
          title: "Déployer une action",
          authenticationRequired: true,
        },
        sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
      },
    ],
  },
  // {
  //   path: "/ceate-study-eating",
  //   component: EatingStudyPage,
  //   children: [
  //     {
  //       path: "",
  //       name: "CreateEatingStudy",
  //       component: CreateEatingStudy,
  //       meta: {
  //         title: "create-study-eating",
  //       },
  //       // sitemapGroup: Constants.SitemapGroups.LAW,
  //     },
  //   ],
  // },
  {
    path: "/modifier-ma-cantine/:canteenUrlComponent",
    name: "CanteenModification",
    props: true,
    component: CanteenEditor,
    redirect: { name: "CanteenForm" },
    children: [
      {
        path: "modifier",
        name: "CanteenForm",
        props: true,
        component: CanteenForm,
        meta: {
          authenticationRequired: true,
          title: "Modifier ma cantine",
        },
      },
      {
        path: "satellites",
        name: "SatelliteManagement",
        component: SatelliteManagement,
        meta: {
          authenticationRequired: true,
          title: "Gérer mes satellites",
        },
      },
      {
        path: "gestionnaires",
        name: "CanteenManagers",
        component: CanteenManagers,
        meta: {
          authenticationRequired: true,
          title: "Gérer mon équipe",
        },
      },
      {
        path: "generer-mon-affiche",
        name: "CanteenGeneratePoster",
        component: CanteenGeneratePoster,
        meta: {
          authenticationRequired: true,
          title: "Générer mon affiche",
        },
      },
      {
        path: "supprimer",
        name: "CanteenDeletion",
        component: CanteenDeletion,
        meta: {
          authenticationRequired: true,
          title: "Supprimer ma cantine",
        },
      },
      {
        path: "publier",
        name: "PublicationForm",
        component: PublicationForm,
        meta: {
          authenticationRequired: true,
          title: "Éditer mon affiche",
        },
      },
      {
        path: "publier-mes-satellites",
        name: "PublishSatellites",
        component: PublishSatellites,
        meta: {
          authenticationRequired: true,
          title: "Publier mes satellites",
        },
      },
    ],
  },
  {
    path: "/diagnostic-tunnel/:canteenUrlComponent/:year/:measureId",
    name: "DiagnosticTunnel",
    component: DiagnosticTunnel,
    props: true,
    meta: {
      title: "Bilan",
      authenticationRequired: true,
      fullscreen: true,
    },
  },
  {
    path: "/importer-diagnostics",
    name: "DiagnosticsImporter",
    component: DiagnosticsImporter,
    meta: {
      title: "Importer des diagnostics",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/importer-diagnostics/:importUrlSlug",
    name: "DiagnosticImportPage",
    component: DiagnosticImportPage,
    props: true,
  },
  {
    path: "/statistiques-regionales",
    name: "PublicCanteenStatisticsPage",
    component: PublicCanteenStatisticsPage,
    meta: {
      title: "Les cantines dans ma collectivité",
    },
    //sitemapGroup: Constants.SitemapGroups.LAW,
  },
  {
    path: "/accessibilite",
    name: "AccessibilityDeclaration",
    component: AccessibilityDeclaration,
    meta: {
      title: "Déclaration d'accessibilité",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/contact-old",
    name: "ContactPage",
    component: ContactPage,
    meta: {
      title: "Contactez-nous",
    },
    //sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/mes-achats",
    name: "PurchasesHome",
    component: PurchasesHome,
    meta: {
      title: "Mes achats",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/mes-achats/:id",
    name: "PurchasePage",
    component: PurchasePage,
    props: true,
    meta: {
      title: "Modifier mon achat",
      authenticationRequired: true,
    },
  },
  {
    path: "/nouvel-achat/",
    name: "NewPurchase",
    component: PurchasePage,
    meta: {
      title: "Nouvel achat",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/importer-achats",
    name: "PurchasesImporter",
    component: PurchasesImporter,
    meta: {
      title: "Importer des achats",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/synthese-achats",
    name: "PurchasesSummary",
    component: PurchasesSummary,
    meta: {
      title: "Synthèse des achats",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/communaute/",
    name: "CommunityPage",
    component: CommunityPage,
    meta: {
      title: "Webinaires",
    },
    //sitemapGroup: Constants.SitemapGroups.LAW,
  },
  {
    path: "/faq/",
    name: "FaqPage",
    component: FaqPage,
    meta: {
      title: "Foire aux questions",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/plan-du-site/",
    name: "SiteMap",
    component: SiteMap,
    meta: {
      title: "Plan du site",
    },
  },
  {
    path: "/developpement-et-apis/",
    name: "DeveloperPage",
    component: DeveloperPage,
    meta: {
      title: "Développement et APIs",
    },
    //sitemapGroup: Constants.SitemapGroups.ACTION,
  },
  {
    path: "/statistiques-plateforme/",
    name: "ImpactMeasuresPage",
    component: ImpactMeasuresPage,
    meta: {
      title: "Mesures de notre impact",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/webinaires/:webinaireUrlComponent",
    name: "VideoTutorial",
    component: VideoTutorial,
    props: true,
  },
  {
    path: "/les-cantines-de-mon-territoire",
    name: "TerritoryCanteens",
    component: TerritoryCanteens,
    meta: {
      title: "Les cantines de mon territoire",
      authenticationRequired: true,
    },
    beforeEnter: (_to, _from, next) => {
      store.state.loggedUser?.isElectedOfficial ? next() : next({ name: "ManagementPage" })
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/mon-restaurant/tableau-de-bord",
    name: "RestaurantDashboardPage",
    component: RestaurantDashboardPage,
    meta: {
      title: "Mon tableau de bord",
    },
  },
  {
    path: "/diagnostic-gaspillage",
    name: "WasteDiagnosticPage",
    component: WasteDiagnosticPage,
    meta: {
      title: "Diagnostic gaspillage",
    },
  },
  {
    path: "/diagnostic-1",
    name: "FirstDiagnostic",
    component: FirstDiagnosticPage,
    meta: {
      title: "Diagnostic 1 de la semaine",
    },
  },
  {
    path: "/faire-ma-teledeclaration",
    name: "OnlineDeclarationPage",
    component: OnlineDeclarationPage,
    meta: {
      title: "Faire ma télédéclaration",
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/resume-diagnostic-gaspillage",
    name: "WasteDiagnosticResumePage",
    component: WasteDiagnosticResumePage,
    meta: {
      title: "Résumé Diagnostic Gaspillage",
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/nouveau-dashboard-cantine/:canteenId",
    name: "CantineNewDashboard",
    component: CantineNewDashboard,
    props: true,
    meta: {
      title: "Nouveau Dashboard Cantine",
    },
    sitemapGroup: Constants.SitemapGroups.COOK,
  },
  {
    path: "/kezako",
    name: "KezakoPage",
    component: KezakoPage,
    meta: {
      title: "Kezako ?",
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/mon-assiette",
    name: "MyDishPage",
    component: () => import("@/views/MyDishPage.vue"),
    meta: {
      title: "Mon assiette",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.CONSUMER,
  },
  {
    path: "/dashboard-nutritioniste",
    name: "NutritionistDashboardPage",
    component: () => import("@/views/NutritionistDashboardPage.vue"),
    meta: {
      title: "Tableau de bord nutritioniste",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/eating-issue-prediction",
    name: "EatingIssuePrediction",
    component: () => import("@/views/EatingIssuePrediction.vue"),
    meta: {
      title: "Prédiction des problématiques alimentaires",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
  {
    path: "/next-meeting-calendar",
    name: "NextMeeting",
    component: NextMeeting,
    meta: {
      title: "Prochain RDV",
      authenticationRequired: true,
    },
    sitemapGroup: Constants.SitemapGroups.NUTRITIONIST,
  },
]

if (window.ENABLE_DASHBOARD) {
  routes.push({
    path: "/dashboard/:canteenUrlComponent",
    name: "DashboardManager",
    component: DashboardManager,
    props: true,
    meta: {
      title: "Tableau de bord",
      authenticationRequired: true,
    },
  })
  routes.push({
    path: "/ma-progression/:canteenUrlComponent/:year/:measure",
    name: "MyProgress",
    component: MyProgress,
    props: true,
    meta: {
      title: "Ma progression",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  })
}

const vue3Routes = [
  {
    path: "/gaspillage-alimentaire/:canteenUrlComponent",
    name: "WasteMeasurements",
  },
  {
    path: "/importer-des-donnees",
    name: "DiagnosticsImporter",
    meta: {
      title: "Importer vos données",
      authenticationRequired: true,
    },
    //sitemapGroup: Constants.SitemapGroups.DIAG,
  },
  {
    path: "/evaluation-gaspillage-alimentaire/:canteenUrlComponent/:id?",
    name: "WasteMeasurementTunnel",
  },
  {
    path: "/mentions-legales",
    name: "LegalNotices",
    meta: {
      title: "Mentions Légales",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/accessibilite",
    name: "AccessibilityDeclaration",
    meta: {
      title: "Déclaration d'accessibilité",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/cgu",
    name: "CGU",
    meta: {
      title: "Conditions générales d'utilisation",
    },
    sitemapGroup: Constants.SitemapGroups.SITE,
  },
  {
    path: "/contact",
    name: "ContactPage",
    meta: {
      title: "Contactez-nous",
    },
    //sitemapGroup: Constants.SitemapGroups.SITE,
  },
]
const VUE3_PREFIX = "/v2"
vue3Routes.forEach((r) => {
  r.path = VUE3_PREFIX + r.path
})
routes.push(...vue3Routes)

routes.push({
  path: "/:catchAll(.*)",
  component: NotFound,
  name: "NotFound",
})

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) return { selector: to.hash, offset: { y: 200 } }
    if (to.name === from.name && this.app.$vuetify.breakpoint.mdAndUp) return savedPosition
    return { x: 0, y: 0 }
  },
})

function isRouteAuthorized(to) {
  const autorizedRoutes = routes.filter((route) => {
    if (!route.requiredPermissions) return true
    return route.requiredPermissions.includes(store.state.loggedUser.job)
  })
  return autorizedRoutes.some((route) => {
    return route.path == to.path || route.path + "/" == to.path
  })
}

function goToRoute(to, next) {
  const isRouteAuthorizedCst = isRouteAuthorized(to)
  if (isRouteAuthorizedCst) {
    next()
  } else {
    next()
    // next({ name: "NotFound" })
  }
}

function chooseAuthorisedRoute(to, next) {
  if (to.meta.home && store.state.loggedUser && !store.state.loggedUser.isStaff) next({ name: "SurveyLinksHome" })
  else if (to.meta.home && store.state.loggedUser && !store.state.loggedUser.isDev) next({ name: "ManagementPage" })
  else if (to.meta.home && store.state.loggedUser && store.state.loggedUser.isDev) next({ name: "DeveloperPage" })
  else if (to.meta.home) next({ name: "LandingPage" })
  else if (!to.meta.authenticationRequired || store.state.loggedUser) goToRoute(to, next)
  else window.location.href = `/s-identifier?next=${to.path}`
}

router.beforeEach((to, from, next) => {
  store.dispatch("removeNotifications")

  // si les données du store ne sont pas encore chargées
  if (!store.state.initialDataLoaded) {
    store
      .dispatch("fetchInitialData")
      .then(() => {
        chooseAuthorisedRoute(to, next)
      })
      .catch((e) => {
        console.error(`An error occurred: ${e}`)
        next({ name: "LandingPage" })
      })
  } else {
    chooseAuthorisedRoute(to, next)
  }
  // TODO: audit code to check that notifies are placed after redirects
  // TODO: check the tunnel to see if the change of step also clears notifications
})

export { router, routes }
